module.exports = __webpack_public_path__ + "static/media/lk_restroom_icon.9c112160.png";